/* eslint-disable camelcase */
import { Config } from '../config';

const getHeaders = () => Config.utilities.authorizedHeader();

export const UniPaymentService = {
  // Deposit APIs
  QueryDeposits: data => fetch(Config.utilities.servicePayment('/payment/unipayment/invoices'), {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data),
  }).then(r => r.json()),

  GetDepositDetails: depositId => fetch(Config.utilities.servicePayment(`/payment/unipayment/invoice/${depositId}`), {
    method: 'GET',
    headers: getHeaders(),
  }).then(r => r.json()),

  // Beneficiary APIs
  QueryBeneficiaries: data => fetch(Config.utilities.servicePayment('/payment/unipayment/beneficiaries'), {
    method: 'GET',
    headers: getHeaders(),
    // body: JSON.stringify(data)
  }).then(r => r.json()),

  GetBeneficiary: beneficiaryId => fetch(Config.utilities.servicePayment(`/payment/unipayment/beneficiaries/${beneficiaryId}`), {
    method: 'GET',
    headers: getHeaders(),
  }).then(r => r.json()),

  CreateBeneficiary: data => fetch(Config.utilities.servicePayment('/payment/unipayment/beneficiaries/Create'), {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data),
  }).then(r => r.json()),

  UpdateBeneficiary: (beneficiaryId, data) => fetch(Config.utilities.servicePayment(`/payment/unipayment/beneficiaries/${beneficiaryId}`), {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data),
  }).then(r => r.json()),

  DeleteBeneficiary: beneficiaryId => fetch(Config.utilities.servicePayment(`/payment/unipayment/beneficiaries/${beneficiaryId}`), {
    method: 'DELETE',
    headers: getHeaders(),
  }).then(r => r.json()),

  // Payment Method APIs
  QueryPaymentMethods: data => fetch(Config.utilities.servicePayment('/payment/unipayment/payment-methods'), {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data),
  }).then(r => r.json()),

  GetPaymentMethod: beneficiary_id => fetch(Config.utilities.servicePayment(`/payment/unipayment/paymentmethods/${beneficiary_id}`), {
    method: 'GET',
    headers: getHeaders(),
  }).then(r => r.json()),

  CreatePaymentMethod: data => fetch(Config.utilities.servicePayment(`/payment/unipayment/paymentmethods/create?beneficiaryId=${data.beneficiary_id}`), {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data),
  }).then(r => r.json()),

  UpdatePaymentMethod: (paymentMethodId, data) => fetch(Config.utilities.servicePayment(`/payment/unipayment/paymentmethods/${paymentMethodId}`), {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data),
  }).then(r => r.json()),

  DeletePaymentMethod: paymentMethodId => fetch(Config.utilities.servicePayment(`/payment/unipayment/payment-methods/${paymentMethodId}`), {
    method: 'DELETE',
    headers: getHeaders(),
  }).then(r => r.json()),

  // Payment (Withdrawal) APIs
  QueryPayments: data => fetch(Config.utilities.servicePayment('/payment/unipayment/payments/query'), {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data),
  }).then(r => r.json()),

  GetPayment: paymentId => fetch(Config.utilities.servicePayment(`/payment/unipayment/payments/${paymentId}`), {
    method: 'GET',
    headers: getHeaders(),
  }).then(r => r.json()),

  CreatePayment: data => fetch(Config.utilities.servicePayment('/payment/unipayment/payments/create'), {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data),
  }).then(r => r.json()),

  ConfirmPayment: paymentId => fetch(Config.utilities.servicePayment(`/payment/unipayment/payments/${paymentId}/confirm`), {
    method: 'PUT',
    headers: getHeaders(),
  }).then(r => r.json()),

  CancelPayment: paymentId => fetch(Config.utilities.servicePayment(`/payment/unipayment/payments/${paymentId}/cancel`), {
    method: 'PUT',
    headers: getHeaders(),
  }).then(r => r.json()),

  GetPaymentFee: data => fetch(Config.utilities.servicePayment('/payment/unipayment/payments/fee'), {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data),
  }).then(r => r.json()),

  // Wallet APIs
  GetWalletBalances: () => fetch(Config.utilities.servicePayment('/payment/unipayment/wallet/balances'), {
    method: 'GET',
    headers: getHeaders(),
  }).then(r => r.json()),

  GetWalletAccounts: () => fetch(Config.utilities.servicePayment('/payment/unipayment/wallet/accounts'), {
    method: 'GET',
    headers: getHeaders(),
  }).then(r => r.json()),
};
